import React from 'react';
import { useTranslation } from 'react-i18next';
import { inject, observer } from 'mobx-react';

import compose from 'helpers/compose';
import Container from '@material-ui/core/Container';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import Layout from 'components/Layout';
import Background from 'components/Layout/Background';
import { UserStoreKC } from 'stores/userStoreKC';
import { RootStore } from 'stores/rootStore';
import useStyles from './styles';

interface Props {
  userStore: UserStoreKC;
  rootStore: RootStore;
}

const ClientError: React.FC<Props> = ({ userStore, rootStore }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Layout title={t('client_error_title')}>
      <Background>
        <Container maxWidth="md">
          <Typography variant="h3">{t('client_error_title')}</Typography>
          <Typography
            className={classes.info}
            dangerouslySetInnerHTML={{
              __html: t(typeof userStore.clientError === 'string' ? userStore.clientError : 'client_error_info', {
                interpolation: { escapeValue: false },
              }),
            }}
          />
          <div style={{ textAlign: 'center' }}>
            <Button variant="contained" color="primary" onClick={() => userStore.fetchClientData()}>
              {t('client_error_retry')}
            </Button>
          </div>
        </Container>
      </Background>
    </Layout>
  );
};

export default compose(inject('userStore','rootStore'), observer)(ClientError);
